import { observer } from "mobx-react-lite";
import { usePopupStore } from "../..";
import useNavigateToLocation from "../../hooks/useNavigateToLocation";
import ILocation from "../../interfaces/ILocation";
import PopupType from "../../interfaces/PopupType";
import { formatDate, formatNumber, formatPrice } from "../../utils/utils";
import commonStyles from "../Common.module.css";
import Grid from "../Grid";

function LocationsGrid({ locations, controls, setSelectedLocations }: ILocationsGridProps) {
    const popupStore = usePopupStore();
    const navigateToLocation = useNavigateToLocation();

    return (
        <Grid
            data={locations}
            headers={[
                {
                    align: "left",
                    titleStrings: ["SITE NAME"],
                    getValue: item => item.siteName,
                    getLabel: item => item.siteName,
                },
                {
                    align: "left",
                    isFullWidth: true,
                    titleStrings: ["ADDRESS"],
                    getValue: item => item.address,
                    getLabel: item => item.address,
                },
                {
                    titleStrings: ["ZONING"],
                    getValue: item => item.zoning,
                    getLabel: item => item.zoning,
                },
                {
                    titleStrings: ["BUILDING", "SIZE"],
                    getValue: item => item.buildingSize,
                    getLabel: item => item.buildingSize ? formatNumber(item.buildingSize) : "",
                },
                {
                    titleStrings: ["LAND", "SIZE"],
                    getValue: item => item.landSize,
                    getLabel: item => item.landSize ? formatNumber(item.landSize) : "",
                },
                {
                    titleStrings: ["OWNER"],
                    getValue: item => item.ownerName,
                    getLabel: item => item.ownerName,
                },
                {
                    titleStrings: ["DATE SOLD"],
                    getValue: item => item.dateSold,
                    getLabel: item => item.dateSold ? formatDate(item.dateSold) : "",
                },
                {
                    titleStrings: ["SALE PRICE"],
                    getValue: item => item.salePrice,
                    getLabel: item => !!item.salePrice ? formatPrice(item.salePrice) : "",
                },
                {
                    align: "left",
                    titleStrings: ["OWNER ADDRESS"],
                    getValue: item => item.ownerAddress,
                    getLabel: item => item.ownerAddress,
                },
                {
                    align: "left",
                    titleStrings: ["NOTES"],
                    getValue: item => item.notes,
                    getLabel: item => item.notes,
                },
            ]}
            getId={item => item.id}
            downloadFileName={"Locations"}
            onRowClick={item => navigateToLocation(item.id)}
            isRowActive={item => popupStore.type === PopupType.Location && popupStore.id === item.id}
            setSelectedItems={setSelectedLocations}
            header={<div className={[commonStyles.gridTitle, commonStyles.header].join(" ")}>{locations.length} Locations</div>}
            controls={controls}
        />
    );
}

export default observer(LocationsGrid);

interface ILocationsGridProps {
    locations: ILocation[];
    controls?: React.ReactNode[];
    setSelectedLocations?: (locations: ILocation[]) => void;
}